import { Component, OnInit } from '@angular/core';
import { FORMS, API, CODFUNC, GENERALES } from '../../../_config/strings';
import { NetworkHelperService } from '../../../_services/network-helper.service';
import {Subject} from 'rxjs/Subject';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listar-orden-pendiente-apoyo',
  templateUrl: './listar-orden-pendiente-apoyo.component.html',
  styleUrls: ['./listar-orden-pendiente-apoyo.component.scss']
})
export class ListarOrdenPendienteApoyoComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

    FORMS: any;
    API: any;
    CODFUNC: any;
    PAGE: any;
    GENERALES: any;

    ordenes;

    // array´s
    arrayApoyosSolicitados = [];

  constructor(
    private network: NetworkHelperService,
    private router: Router
  ) {
    this.FORMS = FORMS;
        this.API = API;
        this.CODFUNC = CODFUNC;
        this.GENERALES = GENERALES;
        // this.usuario = JSON.parse(localStorage.getItem('usuario'));
   }

  ngOnInit() {
    this.getApoyosSolicitados();
  }

  getApoyosSolicitados () {
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.apoyos + '/' + this.API.user.listar + '/' + this.API.user.solicitados,
      'GET',
      null
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 200 ) {
        this.arrayApoyosSolicitados = response.Mensaje;
        this.dtTrigger.next();
      } else {
        Swal('Atención', response.Mensaje, 'warning');
      }
    }, err => {
      console.log(err);
      Swal('Error', this.GENERALES.algoOcurrio, 'error');
    });
  }

  apoyoSolicitado (apoyo: any) {
    this.router.navigate(['dashboard/menuAlmacen/listarApoyoTraspaso/materialApoyoSolicitud/', apoyo.ordenTrabajoId ]);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-orden-pendiente-apoyo/listar-orden-pendiente-apoyo.component.ts